//api.js
const BASE_URL = process.env.REACT_APP_BACKEND_URL;
const urlIonos = process.env.REACT_APP_BACKEND_URL;

// Helper to get token from localStorage
const getToken = () => localStorage.getItem("token");

// Generic fetch wrapper with token
const authFetch = async (endpoint, options = {}) => {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
  };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${BASE_URL}${endpoint}`, { ...options, headers });
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "API Error");
  }

  return data;
};

// --------------------
// Auth endpoints
// --------------------
// export const loginUser = async ({ name, email, password }) => {

//     const res = await fetch("https://slllim.de/api/login", {
    
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ name, email, password }),
//   });
//   const data = await res.json();
//   if (!res.ok) throw new Error(data.message || "Login failed");
//   return data;
// };

export const loginUser = async ({ name, email, password }) => {
  return authFetch("/api/login", {
    method: "POST",
    body: JSON.stringify({ name, email, password }),
  });
};

export const registerUser = async ({name, email, password}) => {
   
  return authFetch("/api/register", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, email, password }),
  });
};

// --------------------
// Dashboard data endpoints
// --------------------
export const getDashboardData = async () => {
  return authFetch("/api/data");
};

export const addDashboardData = async (info) => {
  return authFetch("/api/data", {
    method: "POST",
    body: JSON.stringify({ info }),
  });
};

// --------------------
// Any other API endpoints
// --------------------
export const getFoods = async () => authFetch("/api/foods");
export const getDays = async () => authFetch("/api/days");
export const getRecipes = async () => authFetch("/api/recipes");
